import gql from 'graphql-tag'

export const HIGHLIGHTED_SALE_PRODUCTS = gql`
  query HighlightedSalesProducts($app_units: [ID!]!, $activatable: Boolean, $page: Int, $pageSize: Int, $franchise: Boolean, $search: String) {
    highlightedSalesProducts(app_units: $app_units, activatable: $activatable, page: $page, pageSize: $pageSize, franchise: $franchise, search: $search) {
      highlightedSalesProducts {
        _id
        sku
        name
        image_url
        additional_points_rate
        cashback_absolute
        price
        discounted_price
        discount_percentage
        cashback_percentage
        type
        start_date
        end_date
        percentage_discount
        take
        pay
        price
        personalized
        discounted_price
        target_products {
          percentage_discount
          ean
          eans
          name
          sku
        }
      }
    }
  }
`
